var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { inject } from "tsyringe";
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { ExtraFeeTypes } from "../Menu";
import { IdMap } from "../../collections";
import { ProductTypePackagingFeeCreator } from "./ProductTypePackagingFeeCreator";
import { ProductTypePackagingFeeAvailabilityService } from "../AvailabilityService";
let ProductTypePackagingFeeCreatorFactory = class ProductTypePackagingFeeCreatorFactory {
    constructor(extraFeeTypes, productTypePackagingFeeAvailabilityService) {
        this.extraFeeTypes = extraFeeTypes;
        this.productTypePackagingFeeAvailabilityService = productTypePackagingFeeAvailabilityService;
        makeImmutable(this);
    }
    create(selectedPackagingTypeId) {
        return new ProductTypePackagingFeeCreator({
            packagingFeeTypes: this.extraFeeTypes,
            productTypePackagingFeeAvailabilityService: this.productTypePackagingFeeAvailabilityService,
            selectedPackagingTypeId,
        });
    }
};
ProductTypePackagingFeeCreatorFactory = __decorate([
    perRestaurant(),
    __param(0, inject(ExtraFeeTypes)),
    __metadata("design:paramtypes", [typeof (_a = typeof IdMap !== "undefined" && IdMap) === "function" ? _a : Object, typeof (_b = typeof ProductTypePackagingFeeAvailabilityService !== "undefined" && ProductTypePackagingFeeAvailabilityService) === "function" ? _b : Object])
], ProductTypePackagingFeeCreatorFactory);
export { ProductTypePackagingFeeCreatorFactory };
